export default{
  // 后台首页
  'secretary_app':{
    path: '/admin',
    redirect: {
      name: 'admin_batch_list_money'
    },
    meta: {
      login: true,
      roles: ['administrator','school_administrator','college_administrator']
    }
  },

  // 结算批次列表
  'admin_batch_list_home': {
    hidden: false,
    parentPath: 'secretary_app',
    components: 'Layout',
    name: undefined,
    alwaysShow: true,
    path: 'receive',
    meta: {
      title: '教材征订',
      icon: 'table',
      login: true,
      roles: ['administrator'],
    }
  },


  // 配置权限，临时页面
  'admin_permission_config': {
    hidden: true,
    parentPath: 'secretary_app',
    components: 'Layout',
    name: undefined,
    redirect: {
      name: 'admin_permission_config'
    },
    path: 'permission',
    meta: {
      title: '权限管理',
      login: true,
      icon: 'lock',
      roles: ['administrator']
    }
  },

  //系统配置
  'admin_settings':{
    hidden: true,
    parentPath: 'secretary_app',
    components: 'Layout',
    name: undefined,
    redirect: {
      name: 'admin_settings_list'
    },
    path: 'setting',
    meta: {
      title: '系统配置',
      login: true,
      icon: 'lock',
      roles: ['administrator']
    }
  },
  // 前端模块权限配置
  'admin_permission_config_page': {
    hidden: true,
    parentPath: 'admin_permission_config',
    path: 'config',
    meta: {
      title: '配置权限',
      icon: 'component',
      login: true
    }
  },
  'admin_settings_list': {
    hidden: false,
    parentPath: 'admin_settings',
    path: 'list',
    meta: {
      title: '系统配置',
      login: true,
      icon: 'lock',
      roles: ['administrator']
    }
  },

//-----------------------------------------子路由----------------------------------------
  //结算工具
  'admin_batch_list_money': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'batch/list/money',
    meta: {
      title: '批次管理',
      roles: ['administrator']
    }
  },
  // 代管费管理
  'admin_escrow_fee_manage_money': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'escrow',
    meta: {
      roles: ['administrator']
    }
  },
  //信息录入
  'admin_message_import': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'message/import',
    meta: {
      title: '信息录入',
      roles: ['administrator'],
    },
  },
  //教材统计
  'admin_teaching_material_statistics': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'teaching/material/statistics',
    meta: {
      title: '教材统计',
      roles: ['administrator'],
    },
  },
  //发书管理
  'admin_sending_books_management': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'sending/books/management',
    meta: {
      title: '领书管理',
      roles: ['administrator'],
    },
  },
  //班级领书
  'admin_class_receive_books': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'class/receive/books',
    meta: {
      title: '班级领书',
      roles: ['administrator'],
    },
  },
  //学生领书
  'admin_student_textbook': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'student/textbook',
    meta: {
      title: '学生领书',
      roles: ['administrator'],
    },
  },
  //结算管理
  'admin_settlement_management': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'settlement/management',
    meta: {
      title: '结算管理',
      roles: ['administrator'],
    },
  },
  //结算详情
  'admin_settlement_details': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'settlement/details',
    meta: {
      title: '结算详情',
      roles: ['administrator'],
    },
  },
  //班级管理
  'admin_class_management': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'class/management',
    meta: {
      title: '打包管理',
      roles: ['administrator'],
    },
  },
  //教材导出
  'admin_textbook_export': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'textbook/export',
    meta: {
      title: '教材导出',
      roles: ['administrator'],
    },
  },
  //代管费管理
  'admin_escrow_fee': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'escrow/fee',
    meta: {
      title: '代管费管理',
      roles: ['administrator'],
    },
  },
  //学生代管费
  'admin_student_escrow_fee': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'student/escrow/fee',
    meta: {
      title: '学生代管费',
      roles: ['administrator'],
    },
  },

  //数据统计
  'admin_data_statistics': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'data/statistics',
    meta: {
      title: '数据统计',
      roles: ['administrator'],
    },
  },
  //数据中心
  'admin_data_center': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'data/center',
    meta: {
      title: '数据中心',
      roles: ['administrator'],
    },
  },
  //学生信息
  'admin_student_message': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'student/message',
    meta: {
      title: '学生信息',
      roles: ['administrator'],
    },
  },

  //学院列表页
  'admin_college_list_money': {
    parentPath: 'admin_batch_list_home',
    path: 'college/list/money/:book_statement_id(\\d+)',
    meta: {
      title: '学院列表',
      login: true,
      roles: ['administrator']
    }
  },

  //课程使用教材
  'admin_teaching_course_materials': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'teaching/course/materials/:book_statement_id(\\d+)',
    meta: {
      title: '课程使用教材',
      login: true,
      roles: ['administrator']
    }
  },
  //供应商管理
  // 'admin_supplier_management_list': {
  //   hidden: false,
  //   parentPath: 'admin_batch_list_home',
  //   path: 'supplier/management/list',
  //   meta: {
  //     title: '供应商管理',
  //     login: true,
  //     roles: ['administrator']
  //   }
  // },
  //学生结算详情页
  'admin_settlement_student_list_money': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'settlement/student/list/money/:book_statement_id(\\d+)',
    meta: {
      title: '学生结算详情',
      login: true,
      roles: ['administrator']
    }
  },

  //教师教材计划表打印
  'admin_teacher_text_book_print': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'teacher/text/print/:book_statement_id(\\d+)',
    meta: {
      title: '打印教师用书表',
      login: true,
      roles: ['administrator']
    }
  },
  //教师信息表
  'admin_teacher_information_sheet': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'teacher/information/sheet',
    meta: {
      title: '教师信息表',
      login: true,
      roles: ['administrator']
    }
  },
  //库存管理
  // 'admin_inventory_management': {
  //   hidden: false,
  //   parentPath: 'admin_batch_list_home',
  //   path: 'inventory/management',
  //   meta: {
  //     title: '库存管理',
  //     login: true,
  //     roles: ['administrator']
  //   }
  // },
  // //教材计划表
  // 'admin_teaching_material_list': {
  //   hidden: false,
  //   parentPath: 'admin_batch_list_home',
  //   path: 'teaching/material/list/:book_statement_id(\\d+)',
  //   meta: {
  //     title: '学生用书',
  //     login: true,
  //     roles: ['administrator']
  //   }
  // },

  // 教师教材计划表
  'admin_teacher_text_book_schedule': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'teacher/text/book/:book_statement_id(\\d+)',
    meta: {
      title: '教师用书',
      login: true,
      roles: ['administrator']
    }
  },
  //课程管理
  // 'admin_teaching_course_management': {
  //   hidden: false,
  //   parentPath: 'admin_batch_list_home',
  //   path: 'teaching/course/management/:book_statement_id(\\d+)',
  //   meta: {
  //     title: '课程管理',
  //     login: true,
  //     roles: ['administrator']
  //   }
  // },
  //教材管理
  // 'admin_teaching_material_management': {
  //   hidden: false,
  //   parentPath: 'admin_batch_list_home',
  //   path: 'teaching/material/management/:book_statement_id(\\d+)',
  //   meta: {
  //     title: '教材管理',
  //     login: true,
  //     roles: ['administrator']
  //   }
  // },
  //学生列表页
  // 'admin_student_list_money': {
  //   hidden: false,
  //   parentPath: 'admin_batch_list_home',
  //   path: 'student/list/money/:book_statement_id(\\d+)',
  //   meta: {
  //     title: '学生信息管理',
  //     login: true,
  //     roles: ['administrator']
  //   }
  // },
  //结算详情页
  // 'admin_settlement_list_money': {
  //   hidden: false,
  //   parentPath: 'admin_batch_list_home',
  //   path: 'settlement/list/money/:book_statement_id(\\d+)',
  //   meta: {
  //     title: '结算管理',
  //     login: true,
  //     roles: ['administrator']
  //   }
  // },
  //领书申请
  // 'admin_book_collection_list': {
  //   hidden: false,
  //   parentPath: 'admin_batch_list_home',
  //   path: 'settlement/book/collection/:book_statement_id(\\d+)',
  //   meta: {
  //     title: '领书审批',
  //     login: true,
  //     roles: ['administrator']
  //   }
  // },
  // 补订数据
  'admin_data_supply': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'data/supply',
    meta: {
      title: '补订数据',
      roles: ['administrator'],
    },
  },
  'admin_student_book_addition': {
    hidden: false,
    parentPath: 'admin_batch_list_home',
    path: 'data/student/book/addition',
    meta: {
      title: '学生补订',
      roles: ['administrator']
    }
  },
  'admin_student_books_addition': {
    hidden: true,
    parentPath: 'admin_batch_list_home',
    path: 'data/student/books/addition',
    meta: {
      title: '批量补订',
      roles: ['administrator']
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/route.config.js